import {connect} from 'react-redux'
import React, {Component} from 'react'
import moment from 'moment'
import request from 'superagent'
import MetronicIndex from '../layout/metronic/index'
import {Form, FormGroup} from '../component/form/form'
import {Portlet, PortletHead, PortletBody, PortletFooter, PortletAlert} from '../component/widget/portlet'
import BootstrapTable from 'react-bootstrap-table-next'
import apis from '../helper/api'
import localdata from '../helper/localdata'
import action from '../helper/action'
import do_action from '../action'
import config from '../helper/config'
import swal from 'sweetalert'
import util from '../helper/util'
import Modal from 'react-responsive-modal'
import { history } from '../helper/history'
import ModalDenom from '../component/form/dialog_denom'
import ModalKomisi from '../component/form/dialog_komisi'
import ModalBonus from '../component/form/dialog_bonus'

let service_default = "../../swipe/assets/app/media/img/products/service-default.png"
let product_default = "../../swipe/assets/app/media/img/products/default.png"

class MAgentManageService extends Component {
    constructor(props) {
        super(props)
        this.state = {
            data_services: [],
            data_product: [],
            show_service: false,
            show_service_id : "",
            show_service_url : "",
            show_service_name : "",
            show_product_id : "",
            show_product_code : "",
            show_product_url : "",
            show_product_name : "",
            show_denom_name : "",
            show_denom: false,
            show_komisi: false,
            show_komisi_url: "",
            show_bonus: false,
            show_bonus_url: "",
            product_show_more_btn: false,
            product_load_more_flag_processing: false
        }
        this.detil_komisi = this.detil_komisi.bind(this)
        this.detil_bonus = this.detil_bonus.bind(this)
    }

    componentDidMount() {
        this.props.update_current_page('manage-product')
        this.get_services()
    }

    on_error(err) {
        if (err.code == 2006) {
            localdata.clear_data().then((res) => {
                history.replace('/login')
            }).catch((err) => {
                util.log("error: ", err)
            })
        } else if (err.code === 2007) {
            
        } else {
            let msg = "Error: " + err.code
            if (err.message !== undefined) {
                msg = err.message
            }
            swal("Ups!", msg, "warning")
        }
    }

    get_services() {
        let self = this
        let body = {
            "session_id" : this.props.session
        }
        request.post(apis.list_services)
            .set("Content-Type", "application/json")
            .send(body)
            .end(function(err, res) {
                if (err || !res.ok) {
                    util.log("get_services", err)
                } else {
                    util.log("get_services", res)
                    if (res.statusCode == 200) {
                        let payload = res.body
                        if (payload.status == "OK") {
                            if (payload.results) {
                                self.setState({data_services: {data: payload.results.list, next: payload.results.next_page}})
                            }
                        } else {
                            self.on_error(payload.error)
                        }
                    }
                }
            })
    }

    on_input_change(e) {
        this.setState({[e.target.name]: e.target.value})
    }

    detil_service(e, service_id, service_name, service_url) {
        util.log(service_id + " " + service_url)
        let self = this
        let body = {
            "session_id" : this.props.session
        }
        this.setState({show_service_name: service_name, data_product: [], product_show_more_btn: false})
        const target = e.target
        target.disabled = true
        target.classList.add('m-loader', 'm-loader--light', 'm-loader--right')
        request.post(service_url)
            .set("Content-Type", "application/json")
            .send(body)
            .end(function(err, res) {
                if (err || !res.ok) {
                    util.log("get_services", err)
                } else {
                    util.log("get_services", res)
                    if (res.statusCode == 200) {
                        let payload = res.body
                        if (payload.status == "OK") {
                            if (payload.results) {
                                let next_page = ""
                                let show_more = false
                                if (payload.results.next_page !== null) {
                                    next_page = payload.results.next_page
                                    show_more = true
                                }
                                self.setState({data_product: {data: payload.results.list, next: next_page},product_show_more_btn: show_more})
                            }
                        } else {
                            self.on_error(payload.error)
                        }
                    }
                }
                target.disabled = false
                target.classList.remove('m-loader', 'm-loader--light', 'm-loader--right')
            })
    }

    on_product_btn_load_more (next) {
        util.log(next)
        if (next.url) {
            let url = next.url
            let body = {
                "session_id" : this.props.session
            }
            let self = this
            self.setState({product_load_more_flag_processing: true})
            request.post(url)
                .set("Content-Type", "application/json")
                .send(body)
                .end(function(err, res) {
                    if (err || !res.ok) {
                        util.log(err)
                    } else {
                        util.log(res);
                        if (res.statusCode == 200) {
                            let payload = res.body
                            util.log(payload)
                            if (payload.status == "OK") {
                                let data_list = self.state.data_product.data
                                var joined = data_list.concat(payload.results.list)
                                data_list.data = joined
                                
                                let show_more = false
                                if (payload.results.next_page !== null) {
                                    data_list.next = payload.results.next_page
                                    show_more = true
                                }

                                util.log(data_list)
                                self.setState({data_product: data_list, product_show_more_btn: show_more})
                            } else {
                                swal("Ups!", payload.error.message, "warning")
                            }
                        }
                    }
                    self.setState({product_load_more_flag_processing: false})
                })
        }
    }

    detil_product(product_id, product_name, product_url) {
        this.setState({show_denom: true, show_product_id: product_id, show_product_name: product_name, show_product_url: product_url})
    }

    detil_komisi(product_id, product_code, product_name, commision_url) {
        this.setState({show_komisi: true, show_product_id: product_id, show_product_code: product_code, show_denom_name: product_name, show_komisi_url: commision_url})
    }

    detil_bonus(product_id, product_code, product_name, bonus_url) {
        this.setState({show_bonus: true, show_product_id: product_id, show_product_code: product_code, show_denom_name: product_name, show_bonus_url: bonus_url})
    }

    render() {
        let self = this
        return (
        	<div className="row">
                <div className="col-lg-6">
                    <div className="m-portlet">
                        <div className="m-portlet__head">
                            <div className="m-portlet__head-caption">
                                <div className="m-portlet__head-title">
                                    <h3 className="m-portlet__head-text">
                                        Daftar Service
                                    </h3>
                                </div>
                            </div>
                        </div>
                        <div className="m-portlet__body" style={{maxHeight: '1000px', minHeight: '600px',overflow: 'auto'}}>
                            <div className="tab-content">
                                <div className="tab-pane active" id="m_widget4_tab1_content">
                                    <div className="m-widget4">
                                        {this.state.data_services.length !== 0 && this.state.data_services.data !== undefined ?
                                            this.state.data_services.data.map(function(item, key) {
                                                return (<div key={key} className="m-widget4__item">
                                                    <div className="m-widget4__img m-widget4__img--pic">
                                                        <img src={item.logo_filename !== null && item.logo_filename.length !== 0 ? item.logo_filename : service_default} style={{height: 55+'px',width: 55+'px'}}/>
                                                    </div>
                                                    <div className="m-widget4__info">
                                                        <span className="m-widget4__title">
                                                            {item.service_name}
                                                        </span>
                                                        <br/>
                                                        <span className="m-widget4__sub">
                                                            <span style={{fontWeight: 600}} className={item.is_active ? (item.is_exclude ? 'm--font-warning' : 'm--font-primary') : 'm--font-danger'}>
                                                            {item.is_active ? (item.is_exclude ? 'NOT ASSIGNED' : 'ACTIVE') : 'INACTIVE'}</span> {item.description}
                                                        </span>
                                                    </div>
                                                    <div className="m-widget4__ext" style={{display: 'flex',marginTop: '10px'}}>
                                                        {item.next_product ? <button disabled={item.is_active ? (item.is_exclude ? true : false) : true} className="m-btn m-btn--pill m-btn--hover-brand btn btn-sm btn-secondary" onClick={(e) => self.detil_service(e, item.item_id, item.service_name, item.next_product.url)}>
                                                            Produk
                                                        </button> : ''}
                                                    </div>
                                                </div>)
                                        })
                                        : <div style={{textAlign: 'center'}}>Tidak Ada Service Produk</div>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="col-lg-6">
                    <div className="m-portlet m-portlet--full-height ">
                        <div className="m-portlet__head">
                            <div className="m-portlet__head-caption">
                                <div className="m-portlet__head-title">
                                    <h3 className="m-portlet__head-text">
                                        Daftar Produk {this.state.show_service_name}
                                    </h3>
                                </div>
                            </div>
                        </div>
                        <div className="m-portlet__body" style={{maxHeight: '1000px', minHeight: '600px',overflow: 'auto'}}>
                            <div className="tab-content">
                                <div className="tab-pane active" id="m_widget4_tab1_content">
                                    <div className="m-widget4">
                                        {this.state.data_product.length !== 0 && this.state.data_product.data !== undefined ?
                                            this.state.data_product.data.map(function(item, key) {
                                                return (<div key={key} className="m-widget4__item">
                                                    <div className="m-widget4__img m-widget4__img--pic">
                                                        <img src={item.logo_filename && item.logo_filename.length !== 0 ? item.logo_filename : product_default} style={{height: 55+'px',width: 55+'px'}}/>
                                                    </div>
                                                    <div className="m-widget4__info">
                                                        <span className="m-widget4__title">
                                                            {item.product_name}
                                                        </span>
                                                        <br/>
                                                        <div className="m-widget4__sub">
                                                            <span style={{fontWeight: 600}} className={item.is_active ? (item.is_exclude ? 'm--font-warning' : 'm--font-primary') : 'm--font-danger'}>
                                                            {item.is_active ? (item.is_exclude ? 'NOT ASSIGNED' : 'ACTIVE') : 'INACTIVE'}</span> {item.description}
                                                            <br/>
                                                            {item.trx_fee ? <div>
                                                            <span title="End User Fee" className="m-badge m-badge--metal m-badge--wide m-badge--rounded" style={{marginTop: '5px'}}>EUF {item.trx_fee.fee_type === 'PERCENTAGE' ? item.trx_fee.end_user_fee_value + "%" : "Rp." + util.rupiah_format(item.trx_fee.end_user_fee_value)} </span>&nbsp;
                                                            <span title="Discount" className="m-badge m-badge--metal m-badge--wide m-badge--rounded" style={{marginTop: '5px'}}>Disc {item.trx_fee.discount_type === 'PERCENTAGE' ? item.trx_fee.discount_value + "%" : "Rp." + util.rupiah_format(item.trx_fee.discount_value)}</span>
                                                            </div> : ''}
                                                        </div>
                                                    </div>
                                                    <div className="m-widget4__ext" style={{display: 'flex',marginTop: '15px'}}>
                                                        
                                                        {item.next_denom && item.next_denom !== null ? <button disabled={item.is_active ? (item.is_exclude ? true : false) : true} className="m-btn m-btn--pill m-btn--hover-brand btn btn-sm btn-secondary" onClick={(e) => self.detil_product(item.item_id, item.product_name, item.next_denom.url)}>
                                                            Denom
                                                        </button> : <div className="dropdown">
                                                            <button className="btn btn-secondary" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style={{padding: '5px',borderRadius: '50%',marginLeft: '5px',height: '30px',width: '30px'}}>
                                                                <i className="la la-ellipsis-h" style={{fontSize: 'medium'}}></i>
                                                            </button>
                                                            <div className="dropdown-menu" aria-labelledby="dropdownMenuButton" x-placement="bottom-start" style={{position: 'absolute', transform: 'translate3d(0px, 37px, 0px)', top: '0px', left: '0px', willChange: 'transform'}}>

                                                                {item.next_commission && item.next_commission !== null ?<a className="dropdown-item" style={{cursor:'pointer'}} onClick={(e) => self.detil_komisi(item.product_id, -1, item.product_name, item.next_commission.url)}>
                                                                    Komisi Setting
                                                                    </a> : ''}

                                                                {item.next_bonus && item.next_bonus !== null ?<a className="dropdown-item" style={{cursor:'pointer'}} onClick={(e) => self.detil_bonus(item.product_id, -1, item.product_name, item.next_bonus.url)}>
                                                                    Bonus Setting
                                                                    </a> : ''}

                                                            </div>
                                                        </div>}
                                                    </div>
                                                </div>)
                                        })
                                        : <div style={{}}>Pilih detil service untuk menampilkan halaman ini</div>}

                                        {this.state.product_show_more_btn ? <button type="button" style={{width: '-webkit-fill-available', marginTop: '20px'}} onClick={(e) => this.on_product_btn_load_more(this.state.data_product.next)} className={this.state.product_load_more_flag_processing ? 'btn btn-secondary m-loader m-loader--primary m-loader--right' : 'btn btn-secondary'}>
                                            Load More
                                        </button> : ''}

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {this.state.show_denom ? <ModalDenom data={{product_id : this.state.show_product_id, product_name: this.state.show_product_name, product_url: this.state.show_product_url,  close : ()=>{
                    self.setState({show_denom: false})
                }}} on_detil_komisi={this.detil_komisi} on_detil_bonus={this.detil_bonus}/> : ''}

                {this.state.show_komisi ? <ModalKomisi data={{product_id : this.state.show_product_id, product_code: this.state.show_product_code, product_name: this.state.show_denom_name, komisi_url: this.state.show_komisi_url,  close : ()=>{
                    self.setState({show_komisi: false})
                }}}/> : ''}

                {this.state.show_bonus ? <ModalBonus data={{product_id : this.state.show_product_id, product_code: this.state.show_product_code, product_name: this.state.show_denom_name, bonus_url: this.state.show_bonus_url,  close : ()=>{
                    self.setState({show_bonus: false})
                }}}/> : ''}

            </div>
        )
    }
}

const mapDispatchToProps = (dispatch) => ({
    update_current_page:  val => dispatch(do_action(action.ACTION_UPDATE_CURRENT_PAGE, val)),
    update_balance: val => dispatch(do_action(action.ACTION_UPDATE_USER_BALANCE, val))
})

const mapStateToProps = (state) => ({
    session : state.Session,
    profile: state.Profile
})

export default connect(mapStateToProps, mapDispatchToProps)(MAgentManageService)



// WEBPACK FOOTER //
// ./src/component/magent_manage_service.js